"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoToCheckoutEvents = void 0;
var GoToCheckoutEvents;
(function (GoToCheckoutEvents) {
    GoToCheckoutEvents["INVALID_BASKET"] = "goToCheckout:invalidBasket";
    GoToCheckoutEvents["VALID_BASKET"] = "goToCheckout:validBasket";
})(GoToCheckoutEvents = exports.GoToCheckoutEvents || (exports.GoToCheckoutEvents = {}));
